import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useApp } from '../context/AppContext';
import PostCard from './PostCard';

export default function Profile() {
  const { state, dispatch, getUser } = useApp();
  const userId = state.viewUserId || state.currentUserId;
  const user = getUser(userId);
  const isMe = userId === state.currentUserId;
  const me = getUser(state.currentUserId);
  const isFollowing = me.following.includes(userId);
  const userPosts = state.posts.filter((p) => p.userId === userId);

  return (
    <div className="profile">
      <motion.div
        className="profile-header"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: 'spring', stiffness: 200 }}
      >
        <div className="profile-cover">
          <motion.div
            className="profile-avatar-large"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: 'spring', stiffness: 300, delay: 0.1 }}
          >
            {user.avatar ? (
              <img src={user.avatar} alt="" />
            ) : (
              <span>{user.name[0]}</span>
            )}
          </motion.div>
        </div>

        <div className="profile-info">
          <h2 className="profile-name">{user.name}</h2>
          <p className="profile-bio">{user.bio}</p>

          <div className="profile-stats">
            <motion.div className="stat" whileHover={{ scale: 1.1 }}>
              <span className="stat-num">{userPosts.length}</span>
              <span className="stat-label">动态</span>
            </motion.div>
            <motion.div className="stat" whileHover={{ scale: 1.1 }}>
              <span className="stat-num">{user.following.length}</span>
              <span className="stat-label">关注</span>
            </motion.div>
            <motion.div className="stat" whileHover={{ scale: 1.1 }}>
              <span className="stat-num">{user.followers.length}</span>
              <span className="stat-label">粉丝</span>
            </motion.div>
          </div>

          {isMe ? (
            <motion.button
              className="btn-edit-profile"
              onClick={() => dispatch({ type: 'SET_VIEW', payload: { view: 'edit-profile' } })}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              ✏️ 编辑资料
            </motion.button>
          ) : (
            <motion.button
              className={`btn-follow ${isFollowing ? 'following' : ''}`}
              onClick={() => dispatch({ type: 'TOGGLE_FOLLOW', payload: userId })}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {isFollowing ? '已关注 ✓' : '+ 关注'}
            </motion.button>
          )}
        </div>

        <div className="profile-follow-lists">
          <div className="follow-section">
            <h3>关注 ({user.following.length})</h3>
            <div className="follow-avatars">
              {user.following.map((fid) => {
                const f = getUser(fid);
                return (
                  <motion.button
                    key={fid}
                    className="follow-avatar-item"
                    onClick={() => dispatch({ type: 'SET_VIEW', payload: { view: 'profile', userId: fid } })}
                    whileHover={{ scale: 1.15, y: -4 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <div className="follow-avatar">
                      {f.avatar ? <img src={f.avatar} alt="" /> : <span>{f.name[0]}</span>}
                    </div>
                    <span className="follow-name">{f.name}</span>
                  </motion.button>
                );
              })}
              {user.following.length === 0 && <span className="empty-follow">暂无关注</span>}
            </div>
          </div>
          <div className="follow-section">
            <h3>粉丝 ({user.followers.length})</h3>
            <div className="follow-avatars">
              {user.followers.map((fid) => {
                const f = getUser(fid);
                return (
                  <motion.button
                    key={fid}
                    className="follow-avatar-item"
                    onClick={() => dispatch({ type: 'SET_VIEW', payload: { view: 'profile', userId: fid } })}
                    whileHover={{ scale: 1.15, y: -4 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <div className="follow-avatar">
                      {f.avatar ? <img src={f.avatar} alt="" /> : <span>{f.name[0]}</span>}
                    </div>
                    <span className="follow-name">{f.name}</span>
                  </motion.button>
                );
              })}
              {user.followers.length === 0 && <span className="empty-follow">暂无粉丝</span>}
            </div>
          </div>
        </div>
      </motion.div>

      <div className="profile-posts">
        <h3 className="section-title">TA 的动态</h3>
        <AnimatePresence>
          {userPosts.map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </AnimatePresence>
        {userPosts.length === 0 && (
          <div className="empty-state">
            <span className="empty-icon">📝</span>
            <p>还没有发布动态</p>
          </div>
        )}
      </div>
    </div>
  );
}
